import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { shallowEqual, useDispatch, useSelector } from 'react-redux';

import Card from '../Card/Card';
import Text from '../Text/Text';
import RoleCardFooter from './components/RoleCardFooter';
import ConfirmModal from '../ConfirmModal/ConfirmModal';
import deleteRole from '../../thunks/roles/deleteRole';

const RoleCard = ({ item, onButtonEdit, onButtonView }) => {
  const [deleteConfirmModalVisibility, setDeleteConfirmModalVisibility] = useState(false);
  const dispatch = useDispatch();
  const { deleteRoles: { deleted } } = useSelector((state) => ({
    deleteRoles: state?.deleteRoles
  }), shallowEqual);
  const {
    name, users, role_permission: rolePermissions = []
  } = item;
  const rolePermission = [...rolePermissions].sort((a, b) => a.id - b.id);
  const PERMISSION_COUNT = 4;

  useEffect(() => {
    if (deleted && deleteConfirmModalVisibility) {
      setDeleteConfirmModalVisibility(false);
    }
  }, [deleted]);

  const onDeleteRole = () => {
    dispatch(deleteRole(item?.id));
  };

  return (
    <Card
      footer={(
        <RoleCardFooter
          onButtonEdit={() => onButtonEdit(item)}
          onButtonView={onButtonView}
          onDelete={(!users?.length) ? () => setDeleteConfirmModalVisibility(true) : undefined}
        />
      )}
      headerTitle={name}
      showHeader
      headerBordered={false}
      footerBordered={false}
      styleBodyContainer="px-[30px] py-0 min-h-[227px] w-max"
    >
      <div>
        <Text
          text={`Total users with this role: ${users?.length}`}
          bold
          textStyle="text-romanSilver"
        />
        <div className="mt-[17px]">
          {rolePermission.map(({ id, permission: permis, group }, index) => index <= PERMISSION_COUNT && (
            <div className="flex flex-row items-center py-[6px]" key={id}>
              <div className="bg-primary w-[8px] h-[4px] rounded-[6px] mr-[10px]" />
              <Text
                text={`${group} ${permis} permission`}
                textStyle="text-romanSilver font-normal text-[13px] capitalize"
              />
            </div>
          ))}
          {rolePermission?.length > PERMISSION_COUNT && (
          <div className="flex flex-row items-center py-[6px]">
            <div className="bg-primary w-[8px] h-[4px] rounded-[6px] mr-[10px]" />
            <Text
              text={`and ${rolePermission?.length - PERMISSION_COUNT} more...`}
              textStyle="text-romanSilver font-normal text-[13px] capitalize"
              italic
            />
          </div>
          ) }
        </div>
      </div>
      <ConfirmModal
        visible={deleteConfirmModalVisibility}
        toggleVisible={() => setDeleteConfirmModalVisibility(false)}
        onConfirm={onDeleteRole}
      />
    </Card>
  );
};

RoleCard.propTypes = {
  item: PropTypes.shape({
    id: PropTypes.number,
    name: PropTypes.string,
    users: PropTypes.arrayOf(PropTypes.shape({})),
    role_permission: PropTypes.arrayOf(PropTypes.shape({})),
    permissions: PropTypes.arrayOf(PropTypes.shape({}))
  }),
  onButtonEdit: PropTypes.func,
  onButtonView: PropTypes.func
};

RoleCard.defaultProps = {
  item: {},
  onButtonEdit: undefined,
  onButtonView: undefined
};

export default RoleCard;
